import DuplicateEmbeddedWidgetModal from './DuplicateEmbeddedWidgetModal';
export default DuplicateEmbeddedWidgetModal;
